export default "__VITE_ASSET__NPleCnio__"